
import { LANGUAGES, languageLabel } from '../../lib/languages';
import type { Character } from '../../types/api';

export { languageLabel };
export const LANGUAGE_OPTIONS = LANGUAGES;

export function shortLanguage(code: string): string {
  return code.toLowerCase();
}

export function initials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean).slice(0, 2);
  if (words.length === 0) return '—';
  return words.map((word) => [...word][0] ?? '').join('').toUpperCase();
}

const DATE_FORMAT = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? '—' : DATE_FORMAT.format(date);
}

export function voiceLabel(character: Character): { text: string; muted: boolean } {
  const current = character.current_voice;
  if (current) {
    return { text: current.name, muted: current.status !== 'ready' };
  }
  if (character.voices.length > 0) {
    return { text: `голос не выбран (${character.voices.length} в запасе)`, muted: true };
  }
  return { text: 'голос не привязан', muted: true };
}
